module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bd00845d7d09a355c66ac7951fcf5c8c.png";